import {
  CreateFivGoalDto,
  CreateGoalGroupGoalsDto,
  CreateReportDto,
  GetGoalGroupDto,
  GetGoalGroupGoalsDto,
  IFivGoal,
  IFivGoalGroup,
  IFivReport,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';
import { UpdateFivGoalDto } from 'admiral-core/dist/dtos/fiv/update-fiv-goal.dto';

export class FivApi {
  static getGoalGroup(dto: GetGoalGroupDto): Promise<AxiosResponse<IFivGoalGroup>> {
    return AdmiralApi.apiCall<IFivGoalGroup>({
      method: 'POST',
      url: `${BASE_URL}/fiv/goal/group`,
      data: dto,
    });
  }

  static createReport(dto: CreateReportDto): Promise<AxiosResponse<IFivReport>> {
    return AdmiralApi.apiCall<IFivReport>({
      method: 'POST',
      url: `${BASE_URL}/fiv/report/create`,
      data: dto,
    });
  }

  static createGoal(createGoalDto: CreateFivGoalDto): Promise<AxiosResponse<IFivGoal>> {
    return AdmiralApi.apiCall<IFivGoal>({
      method: 'POST',
      url: `${BASE_URL}/fiv/goal/create`,
      data: createGoalDto,
    });
  }

  static deleteReport(reportId: string): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      method: 'DELETE',
      url: `${BASE_URL}/fiv/report/${reportId}`,
    });
  }

  static getGoalGroupGoals(dto: GetGoalGroupGoalsDto): Promise<AxiosResponse<IFivGoal[]>> {
    return AdmiralApi.apiCall<IFivGoal[]>({
      method: 'POST',
      url: `${BASE_URL}/fiv/goal/group/goals`,
      data: dto,
    });
  }

  static createGoalGroupGoals(
    createGoalGroupGoalsDto: CreateGoalGroupGoalsDto,
  ): Promise<AxiosResponse<IFivGoal>> {
    return AdmiralApi.apiCall<IFivGoal>({
      method: 'POST',
      url: `${BASE_URL}/fiv/goal/group/goals/create`,
      data: createGoalGroupGoalsDto,
    });
  }

  static updateGoal(id: string, dto: UpdateFivGoalDto): Promise<AxiosResponse<IFivGoal>> {
    return AdmiralApi.apiCall<IFivGoal>({
      method: 'PATCH',
      url: `${BASE_URL}/fiv/goal/${id}`,
      data: dto,
    });
  }
}
